import { DEFAULT_LOCALE } from '@constants';

export const formatDuration = (sec: number): string => {
  const hours = Math.floor(sec / 3600);
  const minutes = Math.floor((sec - hours * 3600) / 60);
  const seconds = sec - hours * 3600 - minutes * 60;

  let hoursStr = hours.toString();
  let minutesStr = minutes.toString();
  let secondsStr = seconds.toFixed(6);

  if (hours < 10) {
    hoursStr = `0${hoursStr}`;
  }
  if (minutes < 10) {
    minutesStr = `0${minutesStr}`;
  }
  if (seconds < 10) {
    secondsStr = `0${secondsStr}`;
  }
  return `${hoursStr}:${minutesStr}:${secondsStr}`;
};

export const currencyFormat = (value: number, decimals: number) => {
  return value.toFixed(decimals).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

export const nFormatter = (value: number, decimals = 2) => {
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'K' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const item = lookup
    .slice()
    .reverse()
    .find((e) => value >= e.value);
  return item ? (value / item.value).toFixed(decimals).replace(rx, '$1') + item.symbol : '0';
};

export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))}${sizes[i]}`;
};

export const MutToTez = (mutez = 0) => {
  if (mutez === 0) {
    return 0;
  }
  return Math.round((mutez / 1000000 + Number.EPSILON) * 100) / 100;
};

export const TezToMut = (tezos: number) => tezos * 1000000;

export const getFiat = (currency: string, value: number, locale?: string) => {
  return new Intl.NumberFormat(locale || DEFAULT_LOCALE, { style: 'currency', currency }).format(value);
};
